import { CONSENT_COOKIE_KEY, CONSENT_VERSION, type ConsentState } from "./config";

// Чтение/запись выбора согласия в куке на `.backdoor.tech` — общей с лендингом.
// Вне *.backdoor.tech (localhost, превью) кука host-only.

const MAX_AGE = 60 * 60 * 24 * 365; // год — дальше спросим заново

function cookieAttrs(): string {
  const h = window.location.hostname;
  const domain =
    h === "backdoor.tech" || h.endsWith(".backdoor.tech") ? "; domain=.backdoor.tech" : "";
  const secure = window.location.protocol === "https:" ? "; secure" : "";
  return `${domain}; path=/; max-age=${MAX_AGE}; samesite=lax${secure}`;
}

export function readConsent(): ConsentState | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${CONSENT_COOKIE_KEY}=([^;]*)`));
  if (!m) return null;
  try {
    const s = JSON.parse(decodeURIComponent(m[1])) as ConsentState;
    if (s && typeof s.analytics === "boolean" && s.v === CONSENT_VERSION) return s;
  } catch {
    // повреждённое значение — считаем, что выбора нет
  }
  return null;
}

export function writeConsent(state: ConsentState): void {
  const value = encodeURIComponent(JSON.stringify(state));
  document.cookie = `${CONSENT_COOKIE_KEY}=${value}${cookieAttrs()}`;
}
